/**
 * Recent Projects Block JavaScript
 * Initializes Slick Slider
 */

(function () {
  "use strict";

  function initRecentProjects() {
    const blocks = document.querySelectorAll(".recent-projects");

    blocks.forEach((block) => {
      const slider = block.querySelector(".recent-projects__slider");

      if (!slider) {
        console.warn("[BLOCK] Slider element not found");
        return;
      }

      // Check if jQuery is available
      if (!window.jQuery || typeof $.fn.slick === "undefined") {
        console.warn("[BLOCK] jQuery or Slick not available yet");
        return;
      }

      // Check if already initialized
      if ($(slider).hasClass("slick-initialized")) {
        console.log("[BLOCK] Slider already initialized, skipping");
        return;
      }

      // Find the dots wrapper
      const dotsWrapper = block.querySelector(".slider_dots_wrapper");

      // Initialize Slick Slider
      $(slider).slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: false,
        adaptiveHeight: false,
        autoplay: true,
        autoplaySpeed: 2000,
        autoplayHoverPause: true,
        cssEase: "ease-out",
        appendDots: dotsWrapper ? $(dotsWrapper) : $(slider),
      });

      console.log("[BLOCK] recent-projects slider initialized");
    });
  }

  // Multiple initialization attempts to ensure it works
  function tryInit() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        setTimeout(initRecentProjects, 100);
        setTimeout(initRecentProjects, 300); // Retry in case first attempt was too early
      });
    } else {
      setTimeout(initRecentProjects, 100);
      setTimeout(initRecentProjects, 300); // Retry in case first attempt was too early
    }
  }

  tryInit();
})();
